import { render, staticRenderFns } from "./WorkflowMilestonesModal.vue?vue&type=template&id=998b6a3c&"
import script from "./WorkflowMilestonesModal.vue?vue&type=script&lang=js&"
export * from "./WorkflowMilestonesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports